import numberal from '@tiger/numeral';
import { FC } from 'react';
import { getCurrentTaxYear } from 'app/utils/util/getCurrentTaxYear';
import { ModalHandler } from 'components/Modal';
import { printf } from 'utils/i18n';
import './style.scss';

// NOTE 根据美东时间，在纳税申报截止日期之前为前一年存款。例如,在2024年4月15日之前为2023年存款。超过15日的存款需要按下一年的金额累计
const taxYear = getCurrentTaxYear();

const IRALimitsModal: FC<ModalHandler> = props => {
    const maxContributeAmount = 7000;
    const incomeLow = 146000;
    const incomeHigh = 230000;

    return (
        <div>
            <h3 className="modal-title">{__('IRA contribution and income limits')}</h3>
            <div className="modal-content">
                <p className="modal-text">
                    {printf(
                        __(
                            'For %s, you can contribute up to %s across all of your IRAs, including those outside of TradeUP.'
                        ),
                        taxYear,
                        numberal(maxContributeAmount).format('$0,0.[00]')
                    )}
                </p>
                <p className="modal-text">
                    <a
                        href="https://www.irs.gov/retirement-plans/plan-participant-employee/retirement-topics-ira-contribution-limits"
                        target="_blank"
                        rel="noopener noreferrer">
                        {__('Contributing more than the limit has tax and possible penalty implications.')}
                    </a>
                </p>
                <p className="modal-text">
                    {printf(
                        __(
                            "You can only contribute to a Roth IRA if your modified adjusted gross income is under %s or %s depending on your filing status. These limits don't apply to traditional IRAs. Visit the IRS website or consult a tax advisor for your specific situation."
                        ),
                        numberal(incomeLow).format('$0,0.[00]'),
                        numberal(incomeHigh).format('$0,0.[00]')
                    )}
                </p>
            </div>
            <button className="modal-btn" onClick={props.close}>
                {__('Got it')}
            </button>
        </div>
    );
};

export default IRALimitsModal;
